import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import './favorite.css';

export default function Favorite() {
  const [filmes, setFilmes] = useState([]);

  useEffect(() => {
    const minhaLista = localStorage.getItem('@primeflix');
    setFilmes(JSON.parse(minhaLista) || []);
  }, []);

  function excluirFilme(id) {
    // alert('Excluido => ' + id);
    let filtroFilmes = filmes.filter((item) => {
      return item.id !== id;
    });

    setFilmes(filtroFilmes);

    localStorage.setItem('@primeflix', JSON.stringify(filtroFilmes));
    toast.success('Filme Removido com sucesso!');
  }

  return (
    <div className="meus-filmes">
      <h1>Meus Filmes</h1>

      {filmes.length === 0 && (
        <span>Você não possui nenhum filme salvo :(</span>
      )}

      <ul>
        {filmes.map((item) => {
          return (
            <li key={item.id}>
              <span>{item.title}</span>
              <div>
                <Link to={`/movie/${item.id}`}>Ver Detalhes</Link>
              </div>
              <button onClick={() => excluirFilme(item.id)}>Excluir</button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
